import { Translate } from "@omni/types/utils/translate";
import { cn } from "@omni/utils/styles";

import { RatingField } from "@/components/Form/RHF/FormFields/RatingField/ratingField.component";
import { SwitchField } from "@/components/Form/RHF/FormFields/SwitchField/switchField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import {
    MAX_RATING,
    MIN_RATING,
    SwitchSteps,
    WriteProgressiveReviewFormValues
} from "../writeReview.schema";

type ProductPartialProps = { disabled?: boolean };

const recommendSteps = (t: Translate) => [
    {
        value: SwitchSteps.NO,
        label: t("product.reviews.form.isRecommended.step.no"),
        className: cn("tw:accent-danger")
    },
    { value: SwitchSteps.NO_FEEDBACK },
    {
        value: SwitchSteps.YES,
        label: t("product.reviews.form.isRecommended.step.yes"),
        className: cn("tw:accent-success")
    }
];

const ProductPartial = ({ disabled }: ProductPartialProps) => {
    const { t } = useGranite();

    return (
        <>
            <Row>
                <Col
                    xs={12}
                    sm={6}
                    md={4}
                >
                    <SwitchField<WriteProgressiveReviewFormValues>
                        name="isRecommended"
                        required={false}
                        label={t("product.reviews.form.isRecommended.label")}
                        disabled={disabled}
                        steps={recommendSteps(t)}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <RatingField<WriteProgressiveReviewFormValues>
                        name="ratingQuality"
                        required={false}
                        label={t("product.reviews.form.ratingQuality.label")}
                        disabled={disabled}
                        min={MIN_RATING}
                        max={MAX_RATING}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <RatingField<WriteProgressiveReviewFormValues>
                        name="ratingValue"
                        required={false}
                        label={t("product.reviews.form.ratingValue.label")}
                        disabled={disabled}
                        min={MIN_RATING}
                        max={MAX_RATING}
                    />
                </Col>
            </Row>
        </>
    );
};

export { ProductPartial };
